import { PageHero } from "@/components/site/PageHero";
import { Reveal, SectionLabel } from "@/components/site/primitives";
import { ROADMAP, ROADMAP_COMMITMENT } from "@/data/content";

export default function Roadmap() {
  return (
    <div data-testid="roadmap-page">
      <PageHero
        label="Future Roadmap"
        titleLines={["Towards", "smarter,", "cleaner cities"]}
        intro="Scalable, technology-enabled urban solutions aligned with India's sustainability and sanitation goals — driven by innovation, digital transformation, and inclusive development."
        testId="roadmap-hero"
      />

      {/* Timeline */}
      <section className="px-5 md:px-10 py-24 md:py-32 border-b border-raritan-border">
        <div className="max-w-[1000px] mx-auto">
          <SectionLabel className="mb-16">Future focus areas</SectionLabel>
          <div className="relative">
            <div className="absolute left-0 md:left-[90px] top-0 bottom-0 w-px bg-raritan-border" />
            {ROADMAP.map((r, i) => (
              <Reveal key={r.no} delay={i * 0.1}>
                <div className="relative pl-8 md:pl-[130px] pb-16 last:pb-0">
                  <span className="absolute left-[-5px] md:left-[85px] top-1 w-2.5 h-2.5 bg-raritan-red rounded-full ring-4 ring-raritan-bg" />
                  <span className="md:absolute md:left-0 md:top-0 font-heading font-black text-3xl text-raritan-red/40">{r.no}</span>
                  <h3 className="font-heading font-bold text-2xl md:text-3xl tracking-tight text-raritan-ink">{r.title}</h3>
                  <p className="mt-3 font-body text-lg text-raritan-muted leading-relaxed max-w-xl">{r.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Commitment */}
      <section className="px-5 md:px-10 py-28 md:py-40 bg-raritan-green text-white">
        <div className="max-w-[1100px] mx-auto text-center">
          <SectionLabel className="mb-8 justify-center text-white/60 [&>span]:bg-raritan-red">Our commitment</SectionLabel>
          <Reveal>
            <p className="font-heading font-black uppercase tracking-tighter text-3xl md:text-6xl leading-[1] text-balance">
              &ldquo;{ROADMAP_COMMITMENT}&rdquo;
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
